export default __webpack_public_path__ + "static/media/skip.ff08ad3f.svg";